import { DeliveryDetails } from 'src/features/order/types/delivery-details';
import { Address, Delivery, Recipient, Solution } from '../types';

const addSolution = (solution: Solution, solutions?: Solution[]) => {
  if (solutions) {
    return [...solutions, solution]
  }

  return [solution]
}

export function updateDeliverySolution(updatedSolution: Solution, currentAddressId: string, newAddressId: string, deliveryDetails?: DeliveryDetails, currentDeliveries?: Delivery[]) {

  const deliveries = [...(currentDeliveries || [])];
  const currentSolutionAddress = currentAddressId === 'default' ? {
    address: deliveryDetails?.defaultAddress?.address as Address,
    solutions: deliveryDetails?.defaultAddress?.solutions as Solution[],
    receiverDetails: deliveryDetails?.defaultAddress?.receiverDetails as Recipient,
  } : deliveries?.find(delivery => delivery.id === currentAddressId);

  const existingSolutionIndex = (currentSolutionAddress?.solutions || []).findIndex(sol => sol.productId === updatedSolution.productId);

  if (existingSolutionIndex !== 0 && !existingSolutionIndex) {
    return deliveries
  }

  const newSolutionAddress = deliveries?.find(delivery => delivery.id === newAddressId);

  if (newSolutionAddress?.solutions) {
    newSolutionAddress.solutions = newSolutionAddress.solutions.filter(sol => sol.productId)
  }

  // if current address is the same as the new address update the solution qty
  if (currentAddressId === newAddressId && currentSolutionAddress?.solutions[existingSolutionIndex]) {
    currentSolutionAddress.solutions[existingSolutionIndex] = updatedSolution;
    return deliveries
  }

  // check if qty in the current solution will be less than 1 after updating
  // if true, remove solution from the current address
  if (currentSolutionAddress?.solutions && currentSolutionAddress!.solutions[existingSolutionIndex] && currentSolutionAddress!.solutions[existingSolutionIndex].quantity - updatedSolution.quantity < 1) {
    currentSolutionAddress!.solutions = currentSolutionAddress!.solutions.filter(sol => sol.productId !== updatedSolution.productId);
  }

  const solutionExistsInNewAddress = (newSolutionAddress?.solutions || []).findIndex(sol => sol.productId === updatedSolution.productId);

  if (solutionExistsInNewAddress < 0 && newSolutionAddress) {
    newSolutionAddress.solutions = addSolution(updatedSolution, newSolutionAddress.solutions);

    return deliveries
  }

  if (solutionExistsInNewAddress >= 0 && newSolutionAddress) {
    newSolutionAddress.solutions[solutionExistsInNewAddress] = updatedSolution;
  }

  return deliveries

}